// extracted by mini-css-extract-plugin
export default {"activityElement":"Activity_activityElement__o9N7t","activityElementSpan":"Activity_activityElementSpan__5FPVf"};